import React, { Children, cloneElement } from 'react'
import PropTypes from 'prop-types'
import { Group } from './styles'

export const DefaultToggleGroup = ({ value, onChange, exclusive, size, children, className }) => {
  const handleOptionClick = (optionValue) => {
    if (!onChange) return
    if (exclusive) {
      const newValue = value === optionValue ? '' : optionValue
      onChange(null, newValue)
    } else {
      onChange(null, value)
    }
  }

  const mappedChildren = Children.map(children, (child) => {
    if (!child) return null
    return cloneElement(child, {
      selected: child.props.value === value,
      size,
      onClick: handleOptionClick,
    })
  })

  return <Group className={className}>{mappedChildren}</Group>
}

DefaultToggleGroup.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  exclusive: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  children: PropTypes.node,
  className: PropTypes.string,
}

DefaultToggleGroup.defaultProps = {
  exclusive: true,
  size: 'medium',
}
